import React from 'react';

function Bank(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M11.3917 3.408C11.7699 3.19733 12.2301 3.19733 12.6083 3.408L20.6083 7.8644C21.1057 8.14146 21.353 8.7196 21.2099 9.27064C21.0667 9.82169 20.5693 10.2064 20 10.2064H19.125V17H20.375C20.7202 17 21 17.2798 21 17.625V20.375C21 20.7202 20.7202 21 20.375 21H3.62499C3.27982 21 2.99999 20.7202 2.99999 20.375V17.625C2.99999 17.2798 3.27982 17 3.62499 17H4.87499V10.2064H3.99999C3.43067 10.2064 2.93326 9.82169 2.79014 9.27064C2.64701 8.7196 2.89433 8.14146 3.39169 7.8644L11.3917 3.408ZM17.875 17V10.2064H16.125V17H17.875ZM14.875 17V10.2064H12.625V17H14.875ZM7.87499 17H6.12499V10.2064H7.87499V17ZM9.12499 17V10.2064H11.375V17H9.12499ZM3.99999 8.9564H6.56863H17.4314H20L17.756 7.7064L12 4.5L6.24396 7.7064L3.99999 8.9564ZM4.24999 18.25V19.75H19.75V18.25H4.24999Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Bank;
